import { Icon } from 'components/Icon';

import { BorderlessButton } from './BorderlessButton';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ChevronDownButton(props: Record<string, any>) {
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <BorderlessButton {...props}>
      <Icon name="chevron-down" size={15} />
    </BorderlessButton>
  );
}
